import React from 'react';
import { Facebook, MapPin } from 'lucide-react';
import { useSiteContent } from '../hooks/useSiteContent';

const LOGO_URL = '/logo.png';

export default function Footer() {
  const { content } = useSiteContent();
  const social = content.social || {};
  return (
    <footer className="relative bg-black border-t border-red-600/20 pt-20 pb-8">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-5">
            <a href="#home" className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Fitness Pro" loading="lazy" decoding="async" className="w-14 h-14 object-contain drop-shadow-[0_0_8px_rgba(239,43,43,0.4)] transition-transform duration-300 ease-out hover:rotate-[5deg] hover:scale-110" />
              <div>
                <div className="font-display text-2xl tracking-widest">FITNESS<span className="text-red-500">PRO</span></div>
                <div className="text-[10px] tracking-[0.3em] text-zinc-500 mt-0.5">GALT · SINCE 1992</div>
              </div>
            </a>
            <p className="mt-6 text-sm text-zinc-400 max-w-sm leading-relaxed">A passionate, determined, and supportive fitness community. 17,000 sq ft of premium training, 24/7.</p>
            <div className="mt-6 flex items-center gap-3">
              <a href={social.facebook} target="_blank" rel="noreferrer" data-cursor="hover" className="group flex items-center gap-2 px-4 h-10 rounded-lg bg-zinc-950 border border-zinc-900 hover:border-red-500 hover:bg-red-600/10 transition">
                <Facebook className="w-4 h-4 text-zinc-400 group-hover:text-red-500" />
                <span className="text-[10px] tracking-[0.2em] text-zinc-400 group-hover:text-white transition">FOLLOW ON FACEBOOK</span>
              </a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="text-[10px] tracking-[0.4em] text-red-500 font-bold mb-5">EXPLORE</div>
            <ul className="space-y-3 text-sm">
              {[
                { label: 'Home', href: '#home' },
                { label: 'About', href: '#about' },
                { label: 'Classes', href: '#classes' },
                { label: 'Trainers', href: '#trainers' },
                { label: 'Memberships', href: '#membership-enrollment' },
              ].map((l) => (
                <li key={l.label}><a href={l.href} className="text-zinc-400 hover:text-red-500 transition">{l.label}</a></li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="text-[10px] tracking-[0.4em] text-red-500 font-bold mb-5">SUPPORT</div>
            <ul className="space-y-3 text-sm">
              {[
                { label: 'Contact', href: '#contact' },
                { label: 'Free Tour', href: '#contact' },
                { label: 'Member App', href: '#app' },
                { label: 'Kid Care', href: '#kid-care' },
                { label: 'Reviews', href: '#reviews' },
              ].map((l) => (
                <li key={l.label}><a href={l.href} className="text-zinc-400 hover:text-red-500 transition">{l.label}</a></li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[10px] tracking-[0.4em] text-red-500 font-bold mb-5">VISIT</div>
            <div className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-red-500 mt-1 flex-shrink-0" />
              <p className="text-sm text-zinc-400 leading-relaxed">550 Industrial Dr<br />Galt, CA 95632<br /><span className="text-white">(209) 745-5382</span></p>
            </div>
            <div className="mt-6 inline-flex items-center gap-2 px-3 py-1.5 bg-red-600/10 border border-red-600/30 rounded-full">
              <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" />
              <span className="text-[10px] tracking-[0.3em] text-red-400 font-bold">OPEN NOW</span>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-zinc-900 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-500">© 2026 Fitness Pro Galt. All rights reserved. · Know Pain. Know Gain.</p>
        </div>
      </div>
    </footer>
  );
}
